import { render, staticRenderFns } from "./ManageExpense.vue?vue&type=template&id=2652819b&scoped=true"
import script from "./ManageExpense.vue?vue&type=script&lang=js"
export * from "./ManageExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652819b",
  null
  
)

export default component.exports